import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Device } from '@rocksoft/shared';

export function selectDeviceId(device: Device): string {
  return device.udid;
}

export const adapter: EntityAdapter<Device> = createEntityAdapter<Device>({
  selectId: selectDeviceId,
});

export interface DeviceState extends EntityState<Device> {
  // Global load flags (for all devices)
  hasLoadedAnyLocationsDevice: boolean;
  hasLoadedAnyAppleDevice: boolean;
  hasLoadedAnyInUse: boolean;
  hasLoadedAnyMdmDevice: boolean;

  // Error state
  error?: Error;
}

export const initialState: DeviceState = adapter.getInitialState({
  hasLoadedAnyLocationsDevice: false,
  hasLoadedAnyAppleDevice: false,
  hasLoadedAnyInUse: false,
  hasLoadedAnyMdmDevice: false,
  error: undefined,
});
